/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import msdyn365Commerce, * as Msdyn365 from '@msdyn365-commerce/core';

const FINGERPRINT_API_BASE_URL = 'https://api.fpjs.io/events';

/**
 * GetFingerprint Input Action
 */
export class GetFingerprintInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
   
    constructor() {
       
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetFingerprintCacheKey`;
    public getCacheObjectType = () => 'GetFingerprintObjectType';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetFingerprintData {
    result: any;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetFingerprintInput();
   
        
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetFingerprintInput, ctx: Msdyn365.IActionContext): Promise<IGetFingerprintData> {
    try {

        const postBody = ctx.requestContext.postBody;
        const contentObject = postBody?.content;
        const bodyObject = JSON.parse(contentObject!.toString());
        const requestId = bodyObject.myInputValue;

        
        const secretValue = await msdyn365Commerce.secretManager?.getSecretValue('fingerprint-secrets', ctx.requestContext.apiSettings.baseUrl);
        const secret = secretValue?.value;
        const result = await Msdyn365.sendRequest<any>(`${FINGERPRINT_API_BASE_URL}/${requestId}`,'get',undefined, {headers: {'Auth-API-Key': secret||"", accept: 'application/json'}} ).then((response: Msdyn365.IHTTPResponse<any>) => {
                return response.data;
                });
        return { result: result.products.suspectScore};
    
    } catch(e){
        return {
            result: `GetFingerprint ${JSON.stringify(e)}`
        }
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetFingerprintData>>action,
    // TODO: Give your data action a unique id
    id: 'GetFingerprint',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
})
